module.exports = __webpack_public_path__ + "img/125.aad41961.jpg";